export default __webpack_public_path__ + "static/media/gallery-wps-3.28a0a104.jpg";